<template>
  <div class="page-wrap p-3">
    <div class="page-header p-3 mb-3 mt-3">
      <h3>Добро пожаловать</h3>
    </div>
  </div>
  <div class="page-content mt-3 mb-3">
  </div>
  <div class="page-footer">
  </div>
</template>

<script lang="ts">
import {defineComponent} from "vue";

export default defineComponent({
  name: "WelcomeView"
});
</script>

<style scoped>
</style>
